module.exports = __webpack_public_path__ + "static/media/digita-logo-black.43191dbc.svg";